import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import './Forces.css';
import { Link } from 'react-router-dom';

function Forces () {

    return (
        <div className='forces-page-container' id='forces'>
            <h4 style={{ fontWeight: "700", color: "grey" }}>Partner With Us</h4>
            <h1 style={{ fontWeight: "700" }}>Join Forces With Laundry Buddy</h1>
            <h6 style={{color: "grey", marginTop: "2rem"}}>
                Get on board with Laundry Buddy and take advantage of our revolutionary platform. Whether you offer laundry and dry cleaning, sofa cleaning, house cleaning, shoe cleaning, clean and fold, washing and ironing, steam pressing, or saree polishing services, Laundry Buddy has the tools to help you grow your business. If you are new to the game and want to complete the giants on Day 0, use our brand name by joining us via the franchise model. Contact us today to learn more.
            </h6>
            <Link to="/franchise" style={{ color: "white", textDecoration: "none" }}><Button>Get In Touch</Button></Link>
        </div>
    )
}

export default Forces